import { z } from 'zod';
import { ERPConnectionInfoSchema, ERPConnectionInfo } from './ERPConnectionInfoViewModel';

// schema for ERP Gateway Configuration form
export const ERPGatewayConfigurationFormSchema = z.object({
    CompanyId: z.number().nullable(),
    InvoiceProfileId: z.number().nullable(),
    BuyerDestinationProfileId: z.number().nullable(),
    ERPName: z.string().trim().min(1, { message: 'ERP Name is required' }),
    ERPVersion: z.string().trim().min(1, { message: 'ERP Version is required' }),
    ERPConnectionInfo: ERPConnectionInfoSchema,
    Active: z.boolean(),
    LastHealthCheck: z.any().optional(),
});

export type ERPGatewayConfigurationFormViewModel = z.infer<typeof ERPGatewayConfigurationFormSchema>;

export interface ERPGatewayConfigurationViewModel {
    Id: number | null;
    CompanyID: number | null;
    InvoiceProfileId: number | null;
    BuyerDestinationProfileId: number | null;
    CreatedTime: Date;
    LastUpdateDate: Date;
    RowVersion: string;
    ERPName: string;
    ERPVersion: string;
    ERPConnectionInfo: ERPConnectionInfo;
    LastHealthCheck: string | Date | null;
    Active: boolean;
}
